module.exports = __webpack_public_path__ + "static/media/ic_calendar.ea28c3d0.svg";